(function ($) {
  "use strict";
  window.dataLayer = window.dataLayer || [];

  /*
   ** Tracking des webforms
   */
  if ($(".webform-submission-form .webform-progress").length != 0) {
    var etat_avancement = $(".gtm-webform-etat-avancement").text();
    var titre_etape = $(".gtm-webform-page-actuel .progress-text").text();
    var numero_etape = $(".gtm-webform-page-actuel .progress-marker").text();
    var category = $("form.webform-submission-form").attr("data-webform-category");
    var id = $("form.webform-submission-form").attr("data-webform-id");

    //Le webform calculette affiche un contenu de résultat au lieu de rediriger vers une page
    if (category == "calculette" && $(".resultat-navigation-assistee__body").length != 0) {
      etat_avancement = "webform_results";
      titre_etape = "Résultats";
    }

    //Le message de confirmation d'envoi : succès ou échec
    if ($(".webform-confirmation__message.mail_response_success").length != 0){
      titre_etape = "Confirmation";
    }
    if ($(".webform-confirmation__message.mail_response_failed").length != 0) {
      titre_etape = "Problème";
    }

    window.dataLayer.push({
      'webform_status': etat_avancement,
      'webform_category' : category,
      'webform_step_title': titre_etape,
      'webform_step_number': numero_etape,
      'webform_id': id,
      'event': etat_avancement,
    });

    //console.log(window.dataLayer);
  }

  /*
   ** Tracking des page de résultats de navigation assistée
  */
  if ($("body").hasClass('node-bundle-resultat-navigation-assistee')) {

    window.dataLayer.push({
      'page_type': 'resultat_navigation_assistee',
      'event': 'webform_results',
    });

    //console.log(window.dataLayer);
  }


  /*
   ** Tracking de Booking
   */
  if ($("iframe[src^='https://outlook.office365.com/owa/calendar']").length != 0 && $("#gtm-iframe-booking").length == 0) {
    $("iframe[src^='https://outlook.office365.com/owa/calendar']").wrap('<div id="gtm-iframe-booking"></div>');
  }

})(jQuery);
